// extracted by mini-css-extract-plugin
export default {"main":"Countdown_main__u3mvj"};